import React from "react";
import { Archivo } from '../Archivo';
import { Growl } from "primereact/growl";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import Dropzone from 'react-dropzone';
import { sha256 } from 'js-sha256';

import servicioHttp from "../../servicio/ServicioHttp";
import { obtenerBytesBase64Archivos } from '../../servicio/ServicioLecturaArchivos';
import ServicioArchivos from '../../servicio/ServicioArchivos';
import { Dropdown } from "primereact/dropdown";
import Imagen from '../../Imagenes/Emisiones.png';
import Imagen2 from '../../Imagenes/sua.png';
import servicioObjetos from '../../servicio/ServicioObjetos';
import servicioFormatos from '../../servicio/ServicioFormatos';
import { obtenerObjetoBase64Archivos2023 } from "../../servicio/ServicioLecturaArchivos";
export class Confronta extends React.Component {

    constructor() {
        super();
        this.state = {
            idsenube: 0,
            verModalSua: false,
            verModalEmision: false,
            verModalTotales: false,
            verModalDatosPersonales: false,
            verModalEMA: false,
            verModalEBA: false,
            verModalSalario: false,
            verModalAltaReingreso: false,
            verModalBajas: false,
            verModalIncapacidades: false,
            verModalMovimientosIMSS: false,
            verModalInfonavit: false,
            verModalMovimientosInfonavit: false,
            paginacion: { registrosPorPagina: 10 },
            confronta: {},
            ListaConfrontaGeneral: [],
            listaCambioSalario: [],
            listaAltaReingreso: [],
            listaTotalesEma: [],
            listaDatosPersonales: [],
            listaBaja: [],
            listaCuotasMensuales: [],
            listaIncapacidadesMensual: [],
            respuestaConfronta: {},
            tipoConfronta: [
                { label: "Seleccione una opción", value: null },
                { label: "Confronta EMA", value: "ema" },
                { label: "Confronta EBA", value: "eba" }
            ],
            confrontas: null,
            archivosSua:new Map(),
            archivosCreditos:new Map()
        };
    }

    mostrarModalSua = () => {
        this.setState({ verModalSua: true });
    };
    mostrarModalEmision = () => {
        this.setState({ verModalEmision: true });
    };
    mostrarModalTotales = () => {
        this.setState({ verModalTotales: true });
    };
    mostrarModalDatosPersonales = () => {
        this.setState({ verModalDatosPersonales: true });
    };
    mostrarModalEMA = () => {
        this.setState({ verModalEMA: true });
    };
    mostrarModalEBA = () => {
        this.setState({ verModalEBA: true });
    };
    mostrarModalSalario = () => {
        this.setState({ verModalSalario: true });
    };
    mostrarModalAltaReingreso = () => {
        this.setState({ verModalAltaReingreso: true });
    };
    mostrarModalBajas = () => {
        this.setState({ verModalBajas: true });
    };
    mostrarModalIncapacidades = () => {
        this.setState({ verModalIncapacidades: true });
    };
    mostrarModalMovimientosIMSS = () => {
        this.setState({ verModalMovimientosIMSS: true });
    };
    mostrarModalInfonavit = () => {
        this.setState({ verModalInfonavit: true });
    };
    mostrarModalMovimientosInfonavit = () => {
        this.setState({ verModalMovimientosInfonavit: true });
    };


    cerrarModalSua = () => {
        this.setState({ verModalSua: false });
    }
    cerrarModalEmision = () => {
        this.setState({ verModalEmision: false });
    }
    cerrarModalTotales = () => {
        this.setState({ verModalTotales: false });
    }
    cerrarModalDatosPersonales = () => {
        this.setState({ verModalDatosPersonales: false });
    }
    cerrarModalEMA = () => {
        this.setState({ verModalEMA: false });
    }
    cerrarModalEBA = () => {
        this.setState({ verModalEBA: false });
    }
    cerrarModalSalario = () => {
        this.setState({ verModalSalario: false });
    }
    cerrarModalAltaReingreso = () => {
        this.setState({ verModalAltaReingreso: false });
    }
    cerrarModalBajas = () => {
        this.setState({ verModalBajas: false });
    }
    cerrarModalIncapacidades = () => {
        this.setState({ verModalIncapacidades: false });
    }
    cerrarModalMovimientosIMSS = () => {
        this.setState({ verModalMovimientosIMSS: false });
    }
    cerrarModalInfonavit = () => {
        this.setState({ verModalInfonavit: false });
    }
    cerrarModalMovimientosInfonavit = () => {
        this.setState({ verModalMovimientosInfonavit: false });
    }
    cargarArchivo = (event) => {
        obtenerBytesBase64Archivos(event, this);
    }

    confrontar = () => {
        let { confronta, confrontas } = this.state;
        if (confrontas === "eba") {
            servicioHttp.consumirPostHttp('/confronta/bimestral/procesar.json', confronta).then(response => {
                if (response.data.error === true) {
                    this.growl.show({ severity: 'error', summary: 'Aviso', detail: response.data.mensaje, life: 10000 });
                } else {
                    this.growl.show({ severity: 'success', summary: 'Aviso', detail: "Se realizo la confronta con exito", life: 10000 });
                    this.setState({ respuestaConfronta: response.data.objeto })
                }
            }).catch(error => {

            });
        }
        if (confrontas === "ema") {
            servicioHttp.consumirPostHttp('/confronta/mensual/procesar.json', confronta).then(response => {
                if (response.data.error === true) {
                    this.growl.show({ severity: 'error', summary: 'Aviso', detail: response.data.mensaje, life: 10000 });
                } else {
                    this.growl.show({ severity: 'success', summary: 'Aviso', detail: "Se realizo la confronta con exito", life: 10000 });
                    this.setState({ respuestaConfronta: response.data.objeto })
                }
            }).catch(error => {

            });
        }



    }
    plantillaErrorNombreEmisionDatosPersonales(rowData, column) {
        if (column.rowData.nombreSua !== column.rowData.nombreEmision)
            return <p style={{ color: '#FF334F' }}>{column.rowData.nombreEmision}</p>

        else
            return <p >{column.rowData.nombreEmision}</p>
    }
    plantillaErrorNombreSuaDatosPersonales(rowData, column) {
        if (column.rowData.nombreSua !== column.rowData.nombreEmision)
            return <p style={{ color: '#FF334F' }}>{column.rowData.nombreSua}</p>

        else
            return <p >{column.rowData.nombreSua}</p>
    }

    plantillaErrorCurpSuaDatosPersonales(rowData, column) {
        if (column.rowData.curpSua !== column.rowData.curpEmision)
            return <p style={{ color: '#FF334F' }}>{column.rowData.curpSua}</p>

        else
            return <p >{column.rowData.curpSua}</p>
    }

    plantillaErrorCurpEmisionDatosPersonales(rowData, column) {
        if (column.rowData.curpSua !== column.rowData.curpEmision)
            return <p style={{ color: '#FF334F' }}>{column.rowData.curpEmision}</p>

        else
            return <p >{column.rowData.curpEmision}</p>
    }
    plantillaDiferenciaCuotaFijaEmision(rowData, column) {
        if (column.rowData.cuotaFijaEmision !== column.rowData.cuotaFijaSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.cuotaFijaEmision}</p>

        else
            return <p >{column.rowData.cuotaFijaEmision}</p>
    }

    plantillaDiferenciaCuotaFijaSUA(rowData, column) {
        if (column.rowData.cuotaFijaEmision !== column.rowData.cuotaFijaSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.cuotaFijaSua}</p>

        else
            return <p >{column.rowData.cuotaFijaSua}</p>
    }

    plantillaDiferenciaGuarderiasEmision(rowData, column) {
        if (column.rowData.guarderiasEmision !== column.rowData.guarderiasSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.guarderiasEmision}</p>

        else
            return <p >{column.rowData.guarderiasEmision}</p>
    }

    plantillaDiferenciaGuarderiaSua(rowData, column) {
        if (column.rowData.guarderiasEmision !== column.rowData.guarderiasSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.guarderiasSua}</p>

        else
            return <p >{column.rowData.guarderiasSua}</p>
    }

    plantillaPrestacionesDineroEmision(rowData, column) {
        if (column.rowData.prestacionesEnDineroEmision !== column.rowData.prestacionesEnDineroSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.prestacionesEnDineroEmision}</p>

        else
            return <p >{column.rowData.prestacionesEnDineroEmision}</p>
    }

    plantillaPrestacionesDineroSua(rowData, column) {
        if (column.rowData.prestacionesEnDineroEmision !== column.rowData.prestacionesEnDineroSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.prestacionesEnDineroSua}</p>

        else
            return <p >{column.rowData.prestacionesEnDineroSua}</p>
    }

    plantillaerrorRiesgoTrabajoEmision(rowData, column) {
        if (column.rowData.riesgosDeTrabajoEmision !== column.rowData.riesgosDeTrabajoSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.riesgosDeTrabajoEmision}</p>

        else
            return <p >{column.rowData.riesgosDeTrabajoEmision}</p>
    }

    plantillaRiesgoTrabajoSua(rowData, column) {
        if (column.rowData.riesgosDeTrabajoEmision !== column.rowData.riesgosDeTrabajoSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.riesgosDeTrabajoSua}</p>

        else
            return <p >{column.rowData.riesgosDeTrabajoSua}</p>
    }

    plantillaInvalidezVidaEmision(rowData, column) {
        if (column.rowData.invalidezYVidaEmision !== column.rowData.invalidezYVidaSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.invalidezYVidaEmision}</p>

        else
            return <p >{column.rowData.invalidezYVidaEmision}</p>
    }

    plantillaInvalidezVidaSua(rowData, column) {
        if (column.rowData.invalidezYVidaEmision !== column.rowData.invalidezYVidaSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.invalidezYVidaSua}</p>

        else
            return <p >{column.rowData.invalidezYVidaSua}</p>
    }

    plantillaGastosMedicosEmision(rowData, column) {
        if (column.rowData.gastosMedicosYPensionadosEmision !== column.rowData.gastosMedicosYPensionadosSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.gastosMedicosYPensionadosEmision}</p>

        else
            return <p >{column.rowData.gastosMedicosYPensionadosEmision}</p>
    }

    plantillaGastosMedicosSua(rowData, column) {
        if (column.rowData.gastosMedicosYPensionadosEmision !== column.rowData.gastosMedicosYPensionadosSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.gastosMedicosYPensionadosSua}</p>

        else
            return <p >{column.rowData.gastosMedicosYPensionadosSua}</p>
    }

    plantillaTotalesEmision(rowData, column) {
        if (column.rowData.sua !== column.rowData.emision)
            return <p style={{ color: '#FF334F' }}>{column.rowData.emision}</p>

        else
            return <p >{column.rowData.emision}</p>
    }

    plantillaTotalesSua(rowData, column) {
        if (column.rowData.sua !== column.rowData.emision)
            return <p style={{ color: '#FF334F' }}>{column.rowData.sua}</p>

        else
            return <p >{column.rowData.sua}</p>
    }
    columnaFechaEmision = (rowData, column) => {
        if (rowData.fechaMovimientoEmision !== rowData.fechaMovimientoSua)
            return <div> <p style={{ color: '#FF334F' }}>{servicioFormatos.formatearFecha(rowData.fechaMovimientoEmision)}</p></div>;
        else
            return <div> {servicioFormatos.formatearFecha(rowData.fechaMovimientoEmision)}</div>;
    }
    columnaFechaIncidencia = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fecha)}</div>;
    }

    columnaFechaSua = (rowData, column) => {
        if (rowData.fechaMovimientoSua !== rowData.fechaMovimientoEmision)
            return <div><p style={{ color: '#FF334F' }}>{servicioFormatos.formatearFecha(rowData.fechaMovimientoSua)}</p></div>;

        else
            return <div>{servicioFormatos.formatearFecha(rowData.fechaMovimientoSua)}</div>;
    }
    plantillaExcedenteEmision(rowData, column) {
        if (column.rowData.excedentEmision !== column.rowData.excedenteSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.excedentEmision}</p>

        else
            return <p >{column.rowData.excedentEmision}</p>
    }

    plantillaExcedenteSua(rowData, column) {
        if (column.rowData.excedentEmision !== column.rowData.excedenteSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.excedenteSua}</p>

        else
            return <p >{column.rowData.excedenteSua}</p>
    }

    plantillaDiasEmision(rowData, column) {
        if (column.rowData.diasCotizadosEmision !== column.rowData.diasCotizadosSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.diasCotizadosEmision}</p>

        else
            return <p >{column.rowData.diasCotizadosEmision}</p>
    }

    plantillaDiasSua(rowData, column) {
        if (column.rowData.diasCotizadosEmision !== column.rowData.diasCotizadosSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.diasCotizadosSua}</p>

        else
            return <p >{column.rowData.diasCotizadosSua}</p>
    }

    plantillaDiferenciaTotal(rowData, column) {
        let diferenciaTotal = column.rowData.totalSua - column.rowData.totalEmision;
        if (diferenciaTotal > 0 || diferenciaTotal < 0)
            return <p style={{ color: '#FF334F' }}>{diferenciaTotal.toFixed(2)}</p>

        else
            return <p >{diferenciaTotal}</p>
    }

    plantillaDiferenciaTotalDias(rowData, column) {
        let diferenciaTotalDias = column.rowData.diasCotizadosEmision - column.rowData.diasCotizadosSua - column.rowData.incBimSua - column.rowData.ausBimSua;
        if (diferenciaTotalDias > 0 || diferenciaTotalDias < 0)
            return <p style={{ color: '#FF334F' }}>{diferenciaTotalDias}</p>

        else
            return <p >{diferenciaTotalDias}</p>
    }

    plantillaTotalEmision(rowData, column) {
        if (column.rowData.totalSua !== column.rowData.totalEmision)
            return <p style={{ color: '#FF334F' }}>{column.rowData.totalEmision}</p>
        else
            return <p >{column.rowData.totalEmision}</p>
    }

    plantillaTotalSua(rowData, column) {
        if (column.rowData.totalSua !== column.rowData.totalEmision)
            return <p style={{ color: '#FF334F' }}>{column.rowData.totalSua}</p>
        else
            return <p >{column.rowData.totalSua}</p>
    }

    plantillaSalarioSua(rowData, column) {
        if (column.rowData.salarioSua !== column.rowData.salarioEmision)
            return <p style={{ color: '#FF334F' }}>{column.rowData.salarioSua}</p>
        else
            return <p >{column.rowData.salarioSua}</p>
    }

    plantillaSalarioEmision(rowData, column) {
        if (column.rowData.salarioEmision !== column.rowData.salarioSua)
            return <p style={{ color: '#FF334F' }}>{column.rowData.salarioEmision}</p>
        else
            return <p >{column.rowData.salarioEmision}</p>
    }


    onIndexTemplate = (data, props) => {
        let { idsenube } = this.state;
        return (props.rowIndex + 1) + idsenube;
    }

    descargarResultadosConfrontaMensual = () => {
        let { respuestaConfronta, confrontas } = this.state;
        if (servicioObjetos.esObjetoVacio(respuestaConfronta)) {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: "Debes de procesar los documentos", life: 20000 });
        } else {
            let arregloBytes = ServicioArchivos.base64ToArrayBuffer(respuestaConfronta.archivoResultadosConfrontaGeneral);
            let nombre_archivo = "";
            if (confrontas === "ema") {
                nombre_archivo = "RESULTADOS_EMA.xlsx";
            }
            if (confrontas === "eba") {
                nombre_archivo = "RESULTADOS_EBA.xlsx";
            }


            ServicioArchivos.guardarByteArray(nombre_archivo, arregloBytes);
        }



    }
    descargarConfrontaGeneral = () => {
        let { respuestaConfronta, confrontas } = this.state;
        if (servicioObjetos.esObjetoVacio(respuestaConfronta)) {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: "Debes de procesar los documentos", life: 20000 });
        } else {
            let arregloBytes = ServicioArchivos.base64ToArrayBuffer(respuestaConfronta.archivoConfrontaGeneral);
            let nombre_archivo = "";
            if (confrontas === "ema") {
                nombre_archivo = "CONFRONTA_GENERAL_EMA.xlsx";
            }
            if (confrontas === "eba") {
                nombre_archivo = "CONFRONTA_GENERAL_EBA.xlsx";
            }
            ServicioArchivos.guardarByteArray(nombre_archivo, arregloBytes);
        }


    }

    reiniciarValores = () => {
        this.setState({ respuestaConfronta: {}, confronta: {}, confrontas: null,archivosSua:new Map(),archivosCreditos:new Map() });
    }

    onDrop = (files) => {
        let {archivosSua,confronta}=this.state;
        for (var i = 0; i < files.length; i++) {
            const archivo = files[i];
            let objetoValidacion = {};
            obtenerObjetoBase64Archivos2023(objetoValidacion, archivo).then(response =>{
                let llaveHas256Archivo = sha256(response.stringBase64);
                archivosSua = new Map(archivosSua.set(llaveHas256Archivo, response));
                confronta.sua=[];
                archivosSua.forEach((value, key) => {
                    confronta.sua.push(value.stringBase64);
                });
                this.setState({archivosSua});
                this.setState({confronta});
            });
            
        }        
    }

    onDropCreditos = (files) => {
        let { archivosCreditos, confronta } = this.state;
        for (var i = 0; i < files.length; i++) {
            const archivo = files[i];
            let objetoValidacion = {};
            obtenerObjetoBase64Archivos2023(objetoValidacion, archivo).then(response => {
                let llaveHas256Archivo = sha256(response.stringBase64);
                archivosCreditos = new Map(archivosCreditos.set(llaveHas256Archivo, response));
                confronta.credito = [];
                archivosCreditos.forEach((value, key) => {
                    confronta.credito.push(value.stringBase64);
                });
                this.setState({ archivosCreditos });
                this.setState({ confronta });
            });

        }
    }


    render() {
        let { respuestaConfronta, verModalTotales, verModalDatosPersonales, verModalEMA, verModalEBA, verModalSalario, verModalAltaReingreso, verModalBajas, verModalIncapacidades,
            verModalMovimientosIMSS, verModalInfonavit, verModalMovimientosInfonavit, verModalSua, verModalEmision,
            tipoConfronta, confrontas, archivosSua, archivosCreditos } = this.state;
        return (
            <div className="p-grid">
                <Growl ref={(el) => (this.growl = el)} />
                <div className="p-col-12">
                    <div className="card card-w-tittle">
                        <div className="p-fluid p-grid">

                            <div className="p-col-12 p-md-12">
                                <center><h1>CONFRONTA</h1></center>
                            </div>

                            <div className="p-col-12 p-md-12">

                            </div>

                            <div className="p-col-12 p-md-4">
                                <label>Tipo de confronta: </label>
                            </div>
                            <div className="p-col-12 p-md-5">
                                <Dropdown options={tipoConfronta} value={confrontas} 
                                onChange={(event) => this.setState({ confrontas: event.value, respuestaConfronta: {}, confronta: {} })} />
                            </div>

                            <div className="p-col-12 p-md-12">

                            </div>

                            {confrontas === "ema" || confrontas === "eba" ?
                                <div className="p-col-12 p-md-4">
                                    <label>Selecciona el archivo pago .SUA: </label>
                                </div>
                                : ""}
                            {confrontas === "ema" || confrontas === "eba" ?
                                <div className="p-col-12 p-md-4">
                                    <Dropzone key="dropZone" accept='.sua' onDrop={this.onDrop}>
                                        {({ getRootProps, getInputProps }) => (
                                            <section >
                                                <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                                                    <input   {...getInputProps()} />
                                                    <center><p>Arastra en este cuadro amarillo tus archivos .SUA o da click para buscarlos, puedes cargar más de un archivo .SUA con el mismo Registro patronal</p></center>
                                                </div>
                                                <br></br>
                                                {servicioObjetos.esObjetoVacio([...archivosSua.values()])?null:<strong>Archivos .sua Cargados:</strong>}
                                                <ul>                                                   
                                                    {
                                                        [...archivosSua.values()].map(valor =>                                                           
                                                               (<li>{valor.nombre}</li>)                                                            
                                                        )
                                                    }
                                                </ul>
                                            </section>
                                        )}
                                    </Dropzone>
                                </div>
                                : ""}

                            <div className="p-col-12 p-md-12">
                                <label></label>
                            </div>
                            {confrontas === "ema" || confrontas === "eba" ?
                                <div className="p-col-12 p-md-4">
                                    <label>Selecciona el archivo XLS de la emisión: </label>
                                </div>
                                : ""}
                            {confrontas === "ema" || confrontas === "eba" ?
                                <div className="p-col-12 p-md-4">
                                    <Archivo id="emision" nombre="confronta.emision" etiqueta="Seleccionar Archivo.xls" cambio={this.cargarArchivo} aceptar=".xls" />
                                </div>
                                : ""}

                            <div className="p-col-12 p-md-12">
                                <label></label>
                            </div>
                            {confrontas === "ema" || confrontas === "eba" ?
                                <div className="p-col-12 p-md-12">
                                    <h1>Archivos.txt</h1>
                                </div>
                                : ""}
                            <div className="p-col-12 p-md-12">
                                <label></label>
                            </div>

                            {confrontas === "eba" ?
                                <div className="p-col-12 p-md-4">
                                    <label>Selecciona el TXT de los créditos del SUA: </label>
                                </div>
                                : ""}
                            {confrontas === "eba" ?
                                <div className="p-col-12 p-md-4">
                                    <Dropzone key="dropZone" accept='.txt' onDrop={this.onDropCreditos}>
                                        {({ getRootProps, getInputProps }) => (
                                            <section >
                                                <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                                                    <input   {...getInputProps()} />
                                                    <center><p>Arastra en este cuadro amarillo tus archivos de CRÉDITO o da click para buscarlos, puedes cargar más de un archivo de CRÉDITO con el mismo Registro patronal</p></center>
                                                </div>
                                                <br></br>
                                                {servicioObjetos.esObjetoVacio([...archivosCreditos.values()])?null:<strong>Archivos .txt Cargados:</strong>}
                                                <ul>                                                   
                                                    {
                                                        [...archivosCreditos.values()].map(valor =>                                                           
                                                               (<li>{valor.nombre}</li>)                                                            
                                                        )
                                                    }
                                                </ul>
                                            </section>
                                        )}
                                    </Dropzone>
                                </div>
                                : ""}
                            {confrontas === "eba" ?
                                <div className="p-col-12 p-md-2">
                                    <Button icon="pi-md-help" onClick={this.mostrarModalSua} />
                                </div>
                                : ""}

                            <div className="p-col-12 p-md-12">
                                <label></label>
                            </div>
                            {confrontas === "ema" || confrontas === "eba" ?
                                <div className="p-col-12 p-md-4">
                                    <label>Selecciona el TXT cobra de la Emisión Mensual: </label>
                                </div>
                                : ""}
                            {confrontas === "ema" || confrontas === "eba" ?
                                <div className="p-col-12 p-md-4">
                                    <Archivo id="cobraEma" nombre="confronta.cobraEma" etiqueta="Seleccionar Archivo .txt" cambio={this.cargarArchivo} aceptar=".txt" />
                                </div>
                                : ""}
                            {confrontas === "ema" || confrontas === "eba" ?
                                <div className="p-col-12 p-md-2">
                                    <Button icon="pi-md-help" onClick={this.mostrarModalEmision} />
                                </div>
                                : ""}

                            {confrontas === "eba" ?
                                <div className="p-col-12 p-md-4">
                                    <label>Selecciona el TXT cobra de la Emisión Bimestral: </label>
                                </div>
                                : ""}
                            {confrontas === "eba" ?
                                <div className="p-col-12 p-md-4">
                                    <Archivo id="cobraEba" nombre="confronta.cobraEba" etiqueta="Seleccionar Archivo .txt" cambio={this.cargarArchivo} aceptar=".txt" />
                                </div>
                                : ""}
                            {confrontas === "eba" ?
                                <div className="p-col-12 p-md-2">
                                    <Button icon="pi-md-help" onClick={this.mostrarModalEmision} />
                                </div>
                                : ""}

                            <div className="p-col-12 p-md-12">

                            </div>

                            <div className="p-col-12 p-md-4">

                            </div>
                            <div className="p-col-12 p-md-2">
                                <Button label="Confronta" icon="pi-md-folder" onClick={this.confrontar} />
                            </div>
                            <div className="p-col-12 p-md-2">
                                <Button label="Limpiar" icon="pi-md-refresh" onClick={this.reiniciarValores} />
                            </div>

                            <div className="p-col-12 p-md-12">

                            </div>
                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) ?
                                <div className="p-col-12 p-md-4">
                                    <Button label="Exportación de resultados a Excel" onClick={this.descargarResultadosConfrontaMensual} icon="pi-md-import-export" />
                                </div>
                                : ""}

                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) ?
                                <div className="p-col-12 p-md-4">
                                    <Button label="Exportación de Confronta general" icon="pi-md-import-export" onClick={this.descargarConfrontaGeneral} />
                                </div>
                                : ""}

                            <div className="p-col-12 p-md-12">

                            </div>
                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) ?
                                <div className="p-col-12 p-md-2" >
                                    <Button label="Totales" icon="pi-md-folder" onClick={this.mostrarModalTotales} />
                                </div>
                                : ""}
                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) ?
                                <div className="p-col-12 p-md-2">
                                    <Button label="Datos personales" icon="pi-md-folder" onClick={this.mostrarModalDatosPersonales} />
                                </div>
                                : ""}
                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) && confrontas === "ema" ?
                                <div className="p-col-12 p-md-2">
                                    <Button label="Cuotas mensuales" icon="pi-md-folder" onClick={this.mostrarModalEMA} />
                                </div>
                                : ""}
                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) && confrontas === "eba" ?
                                <div className="p-col-12 p-md-2">
                                    <Button label="Cuotas bimestrales" icon="pi-md-folder" onClick={this.mostrarModalEBA} />
                                </div>
                                : ""}
                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) ?
                                <div className="p-col-12 p-md-2">
                                    <Button label="Cambio de salario" icon="pi-md-folder" onClick={this.mostrarModalSalario} />
                                </div>
                                : ""}
                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) ?
                                <div className="p-col-12 p-md-2">
                                    <Button label="Alta/Reingreso" icon="pi-md-folder" onClick={this.mostrarModalAltaReingreso} />
                                </div>
                                : ""}
                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) ?
                                <div className="p-col-12 p-md-2">
                                    <Button label="Bajas" icon="pi-md-folder" onClick={this.mostrarModalBajas} />
                                </div>
                                : ""}
                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) ?
                                <div className="p-col-12 p-md-2">
                                    <Button label="Incapacidades" icon="pi-md-folder" onClick={this.mostrarModalIncapacidades} />
                                </div>
                                : ""}
                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) ?
                                <div className="p-col-12 p-md-2">
                                    <Button label="Movimientos IMSS" icon="pi-md-folder" onClick={this.mostrarModalMovimientosIMSS} />
                                </div>
                                : ""}
                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) && confrontas === "eba" ?
                                <div className="p-col-12 p-md-2">
                                    <Button label="Infonavit" icon="pi-md-folder" onClick={this.mostrarModalInfonavit} />
                                </div>
                                : ""}
                            {!servicioObjetos.esObjetoVacio(respuestaConfronta) && confrontas === "eba" ?
                                <div className="p-col-12 p-md-3">
                                    <Button label="Movimientos Infonavit" icon="pi-md-folder" onClick={this.mostrarModalMovimientosInfonavit} />
                                </div>
                                : ""}
                            <div className="p-col-12 p-md-12">

                            </div>

                            <Dialog appendTo={document.body} style={{ width: '25%', height: '50%' }} visible={verModalSua} onHide={this.cerrarModalSua.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">
                                        <div className="p-col-12 p-md-12">
                                            <label>Se obtiene del portal del SUA. </label>
                                        </div>
                                        <div className="p-col-12 p-md-12">
                                            <img src={Imagen2} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </Dialog>

                            <Dialog appendTo={document.body} style={{ width: '50%', height: '50%' }} visible={verModalEmision} onHide={this.cerrarModalEmision.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">
                                        <div className="p-col-12 p-md-12">
                                            <label>En el menú "Emisión" en la opción de "Descarga", es de donde se obtiene el archivo (EMA Visor y EBA Visor)</label>
                                        </div>
                                        <div className="p-col-12 p-md-12">
                                            <img src={Imagen} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </Dialog>

                            <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={verModalTotales} onHide={this.cerrarModalTotales.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">

                                        <div className="p-col-12 p-md-12">
                                            <DataTable value={respuestaConfronta.listaResultadoTotalesConfrontaEma} responsive={true} header="Totales" paginator={true} rows={10}>
                                                <Column header="Cuota" field="cuota" autolayout={true} />
                                                <Column header="SUA" body={this.plantillaTotalesSua} autolayout={true} />
                                                <Column header="Emisión" body={this.plantillaTotalesEmision} autolayout={true} />
                                                <Column header="Diferencia" field="diferencia" autolayout={true} />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>

                            <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={verModalDatosPersonales} onHide={this.cerrarModalDatosPersonales.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">

                                        <div className="p-col-12 p-md-12">
                                            <DataTable value={respuestaConfronta.listaResultadoDatosPersonalesEma} responsive={true} header="Datos Personales" paginator={true} rows={10}>
                                                <Column field="Index" header="No." body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                                <Column header="NSS SUA" field="nssSua" autolayout={true} />
                                                <Column header="Nombre SUA" body={this.plantillaErrorNombreSuaDatosPersonales} autolayout={true} />
                                                <Column header="CURP SUA" body={this.plantillaErrorCurpSuaDatosPersonales} autolayout={true} />
                                                <Column header="NSS Emisión" field="nssEmision" autolayout={true} />
                                                <Column header="Nombre Emisión" body={this.plantillaErrorNombreEmisionDatosPersonales} autolayout={true} />
                                                <Column header="CURP Emisión" body={this.plantillaErrorCurpEmisionDatosPersonales} autolayout={true} />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>

                            <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={verModalEMA} onHide={this.cerrarModalEMA.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">

                                        <div className="p-col-12 p-md-12">
                                            <DataTable value={respuestaConfronta.listaResultadoCuotasMensuales} responsive={true} header="Cuotas Mensuales" paginator={true} rows={10} autoLayout={true} scrollable>
                                                <Column field="Index" header="No." body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                                <Column header="NSS " field="nss" autolayout={true} style={{ width: '150px' }} />

                                                <Column header="Nombre" field="nombre" autolayout={true} style={{ width: '150px' }} />

                                                <Column header="Diferencia" field="diferencia" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Total Emision" field="totalEmision" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Total SUA" field="totalSua" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Cuota Fija Emisión" body={this.plantillaDiferenciaCuotaFijaEmision} field="cuotaFijaEmision" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Cuota Fija SUA" body={this.plantillaDiferenciaCuotaFijaSUA} field="cuotaFijaSua" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Excedente Emisión" body={this.plantillaExcedenteEmision} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Excedente SUA" body={this.plantillaExcedenteSua} field="excedenteSua" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Guarderias Emision" body={this.plantillaDiferenciaGuarderiasEmision} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Guarderias SUA" body={this.plantillaDiferenciaGuarderiaSua} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Prestaciones en Dinero EMISIÓN" body={this.plantillaPrestacionesDineroEmision} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Prestaciones en Dinero Sua" body={this.plantillaPrestacionesDineroSua} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Gastos Médicos y Pensionados EMISIÓN" body={this.plantillaGastosMedicosEmision} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Gastos Médicos y Pensionados Sua" body={this.plantillaGastosMedicosSua} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Riesgos de Trabajo EMISIÓN" body={this.plantillaerrorRiesgoTrabajoEmision} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Riesgos de Trabajo Sua" body={this.plantillaRiesgoTrabajoSua} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Invalidez y Vida EMISIÓN" body={this.plantillaInvalidezVidaEmision} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Invalidez y Vida Sua" body={this.plantillaInvalidezVidaSua} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Días Cotizados EMISIÓN" body={this.plantillaDiasEmision} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Días Cotizados Sua" body={this.plantillaDiasEmision} field="diasCotizadosSua" autolayout={true} style={{ width: '150px' }} />

                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>

                            <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={verModalEBA} onHide={this.cerrarModalEBA.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">

                                        <div className="p-col-12 p-md-12">
                                            <DataTable value={respuestaConfronta.resultadoCuotasBimestrales} responsive={true} header="Cuotas Bimestrales" paginator={true} rows={10} autoLayout={true} scrollable>
                                                <Column field="Index" header="No." body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                                <Column header="NSS" field="nss" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Nombre" field="nombre" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Diferencia Total" body={this.plantillaDiferenciaTotal} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Diferencia Días" body={this.plantillaDiferenciaTotalDias} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Total Emisión" body={this.plantillaTotalEmision} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Total SUA" body={this.plantillaTotalSua} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Retiro Emision" field="retiroEmision" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Retiro Sua" field="retiroSua" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="cesantia Emision" field="cesantiaEmision" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="cesantia Sua" field="cesantiaSua" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="aportacion P Emision" field="aportacionPEmision" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="aportacion P Sua" field="aportacionPSua" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="amortizacion Sua" field="amortizacionSua" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="amortizacion Emision" field="amortizacionEmision" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="dias Cotizados Emision" field="diasCotizadosEmision" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="dias Cotizados Sua" field="diasCotizadosSua" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="incMesSua" field="incMesSua" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="ausMesSua" field="ausMesSua" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="incBimSua" field="incBimSua" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="ausBimSua" field="ausBimSua" autolayout={true} style={{ width: '150px' }} />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>

                            <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={verModalSalario} onHide={this.cerrarModalSalario.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">

                                        <div className="p-col-12 p-md-12">
                                            <DataTable value={respuestaConfronta.listaResultadoMovimientoTrabajadorEma} responsive={true} header="Cambio de Salario" paginator={true} rows={10}>
                                                <Column field="Index" header="No." body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                                <Column header="NSS" field="nss" autolayout={true} />
                                                <Column header="Nombre" field="nombre" autolayout={true} />
                                                <Column header="Fecha Movimiento SUA" body={this.columnaFechaSua} autolayout={true} />
                                                <Column header="Fecha Movimiento Emisión" body={this.columnaFechaEmision} autolayout={true} />
                                                <Column header="Salario SUA" body={this.plantillaSalarioSua} autolayout={true} />
                                                <Column header="Salario Emisión" body={this.plantillaSalarioEmision} autolayout={true} />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>

                            <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={verModalAltaReingreso} onHide={this.cerrarModalAltaReingreso.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">

                                        <div className="p-col-12 p-md-12">
                                            <DataTable value={respuestaConfronta.listaResultadoMovimientoTrabajadorEmaReingreso} responsive={true} header="Alta/Reingreso" paginator={true} rows={10}>
                                                <Column field="Index" header="No." body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                                <Column header="NSS" field="nss" autolayout={true} />
                                                <Column header="Nombre" field="nombre" autolayout={true} />
                                                <Column header="Fecha Movimiento SUA" body={this.columnaFechaSua} autolayout={true} />
                                                <Column header="Fecha Movimiento Emisión" body={this.columnaFechaEmision} autolayout={true} />
                                                <Column header="Salario SUA" body={this.plantillaSalarioSua} autolayout={true} />
                                                <Column header="Salario Emisión" body={this.plantillaSalarioEmision} autolayout={true} />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>

                            <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={verModalBajas} onHide={this.cerrarModalBajas.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">
                                        <div className="p-col-12 p-md-12">
                                            <DataTable value={respuestaConfronta.listaResultadoMovimientoTrabajadorEmaBaja} header="Bajas" responsive={true} paginator={true} rows={10}>
                                                <Column field="Index" header="No." body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                                <Column header="NSS" field="nss" autolayout={true} />
                                                <Column header="Nombre" field="nombre" autolayout={true} />
                                                <Column header="Fecha Movimiento SUA" body={this.columnaFechaSua} autolayout={true} />
                                                <Column header="Fecha Movimiento Emisión" body={this.columnaFechaEmision} autolayout={true} />
                                                <Column header="Salario SUA" field="salarioSua" autolayout={true} />
                                                <Column header="Salario Emisión" field="salarioEmision" autolayout={true} />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>

                            <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={verModalIncapacidades} onHide={this.cerrarModalIncapacidades.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">
                                        <div className="p-col-12 p-md-12">
                                            <DataTable value={respuestaConfronta.listaResultadoIncapacidadesEma} responsive={true} header="Incapacidades" paginator={true} rows={10} autoLayout={true} scrollable>
                                                <Column field="Index" header="No." body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                                <Column header="NSS" field="nss" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Nombre" field="nombre" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Fecha" body={this.columnaFechaIncidencia} autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Folio" field="folio" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Días" field="dias" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Días Mes" field="diasMes" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Días Bimestre" field="diasBimestre" autolayout={true} style={{ width: '150px' }} />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>

                            <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={verModalMovimientosIMSS} onHide={this.cerrarModalMovimientosIMSS.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">
                                        <div className="p-col-12 p-md-12">
                                            <DataTable value={respuestaConfronta.listaResultadoMovimientoTrabajadorEmaBaja} responsive={true} header="Bajas" paginator={true} rows={10}>
                                                <Column field="Index" header="No." body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                                <Column header="NSS" field="nss" autolayout={true} />
                                                <Column header="Nombre" field="nombre" autolayout={true} />
                                                <Column header="Fecha Movimiento SUA" body={this.columnaFechaSua} autolayout={true} />
                                                <Column header="Fecha Movimiento Emisión" body={this.columnaFechaEmision} autolayout={true} />
                                                <Column header="Salario SUA" field="salarioSua" autolayout={true} />
                                                <Column header="Salario Emisión" field="salarioEmision" autolayout={true} />
                                            </DataTable>
                                        </div>

                                        <div className="p-col-12 p-md-12">

                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <DataTable value={respuestaConfronta.listaResultadoMovimientoTrabajadorEma} responsive={true} header="Cambios de Salario" paginator={true} rows={10}>
                                                <Column field="Index" header="No." body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                                <Column header="NSS" field="nss" autolayout={true} />
                                                <Column header="Nombre" field="nombre" autolayout={true} />
                                                <Column header="Fecha Movimiento SUA" body={this.columnaFechaSua} autolayout={true} />
                                                <Column header="Fecha Movimiento Emisión" body={this.columnaFechaEmision} autolayout={true} />
                                                <Column header="Salario SUA" field="salarioSua" autolayout={true} />
                                                <Column header="Salario Emisión" field="salarioEmision" autolayout={true} />
                                            </DataTable>
                                        </div>

                                        <div className="p-col-12 p-md-12">

                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <DataTable value={respuestaConfronta.listaResultadoMovimientoTrabajadorEmaReingreso} responsive={true} header="Altas/Reingresos" paginator={true} rows={10}>
                                                <Column field="Index" header="No." body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                                <Column header="NSS" field="nss" autolayout={true} />
                                                <Column header="Nombre" field="nombre" autolayout={true} />
                                                <Column header="Fecha Movimiento SUA" body={this.columnaFechaSua} autolayout={true} />
                                                <Column header="Fecha Movimiento Emisión" body={this.columnaFechaEmision} autolayout={true} />
                                                <Column header="Salario SUA" field="salarioSua" autolayout={true} />
                                                <Column header="Salario Emisión" field="salarioEmision" autolayout={true} />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>

                            <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={verModalInfonavit} onHide={this.cerrarModalInfonavit.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">

                                        <div className="p-col-12 p-md-12">
                                            <DataTable responsive={true} header="Infonavit" paginator={true} rows={10} autoLayout={true} scrollable>
                                                <Column header="No." field="" autolayout={true} style={{ width: '50px' }} />
                                                <Column header="NSS" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Nombre" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Crédito SUA" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Crédito Emisión" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Fecha SUA" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Fecha Emisión" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Aportación Patronal SUA" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Aportación Patronal Emisión" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Amortización SUA" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Amortización Emisión" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Tipo Descuento SUA" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Tipo Descuento Emisión" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Valor Descuento SUA" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Valor Descuento Emisión" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Días SUA" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Días Emisión" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Incidencias (mes)" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Ausencias (mes)" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Inciencias (bim)" field="" autolayout={true} style={{ width: '150px' }} />
                                                <Column header="Ausencias (bim)" field="" autolayout={true} style={{ width: '150px' }} />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>

                            <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={verModalMovimientosInfonavit} onHide={this.cerrarModalMovimientosInfonavit.bind(this)} modal={true} >
                                <div className="card card-w-title">
                                    <div className="p-grid form-group">

                                        <div className="p-col-12 p-md-12">
                                            <DataTable responsive={true} header="Movimientos Infonavit" paginator={true} rows={10}>
                                                <Column header="No." field="" autolayout={true} />
                                                <Column header="NSS" field="" autolayout={true} />
                                                <Column header="Nombre" field="" autolayout={true} />
                                                <Column header="Número Crédito" field="" autolayout={true} />
                                                <Column header="Fecha" field="" autolayout={true} />
                                                <Column header="Descuento" field="" autolayout={true} />
                                                <Column header="Tipo Crédito" field="" autolayout={true} />
                                                <Column header="Movimiento" field="" autolayout={true} />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
